// Feedback-mailto. Adres in stukken, pas bij klik samengevoegd: staat zo niet als kant-en-klaar adres in de bundle (scrapers).
const ADDRESS_PARTS = ['johan', 'jj-data.com'];

export function getFeedbackMailto() {
  return `mailto:${ADDRESS_PARTS.join('@')}?subject=Feedback`;
}

export function openFeedbackMail() {
  window.location.href = getFeedbackMailto();
}
